import axios from '@/axios'

export default {
  get() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/home-settings`)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  save(settings) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/home-settings`, settings)
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
